<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row">
        <div class="page__item">
          <h1 class="title">Организационно правовые формы предприятия</h1>
        </div>
      </div>
    </section>

    <section class="section page__content">
      <div class="page__row page__row_between mb-40">
        <div class="page__row">
          <div class="page__item page__search">
            <SearchForm :value="searchValue"
                        @form-submit="setSearchValue"
            />
          </div>
        </div>
        <div class="page__item">
          <div class="page__row">
            <transition name="fade" v-if="roleAccessRemove">
              <div class="page__item" v-if="isActiveDelete">
                <AppButtonSmRemove title="Удалить" @click.stop.native="showRemoveConfirmationGroup" />
              </div>
            </transition>
            <div class="page__item" v-if="roleAccessCreate">
              <AppButtonSmAdd title="Создать"  @click.stop.native="showModal(null)" />
            </div>
          </div>
        </div>
      </div>
      <div class="page__table mb-20" v-if="forms.length !== 0">
        <AppTable :data="forms"
                  :headers="tableHeaders.headers"
                  :has-checkbox="roleAccessRemove"
                  :isMenuControlsActive=false
                  :all-items-active="tableHeaders.allActive"
                  @toggle-active-item="toggleActiveItem"
                  @toggle-active-all="toggleActiveAll"
                  @edit-this-item="showModal"
                  @show-this-item="showModal"
                  @remove-this-item="showRemoveConfirmation"
        />
      </div>
      <div class="page__row mb-20"  v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="Записи не найдены"/>
        </div>
      </div>
    </section>

    <section class="section page__footer page__footer_has-pagination">
      <div class="page__row" v-if="pagination.lastPage > 1">
        <VPagination
          :pageList="pagination.pageList"
          :currentPage="pagination.currentPage"
          @get-page="getPage"
        />
      </div>
    </section>

    <transition name="fade">
      <AppConfirmation v-if="removeConfirmation.active && roleAccessRemove"
                       :text="removeConfirmation.group ? 'Вы действительно хотите удалить эти формы?' : 'Вы действительно хотите удалить эту форму?'"
                       @confirm="removeConfirmation.group ? removeContractorsFormGroup() : removeContractorsForm()"
                       @reject="closeRemoveConfirmation"
      />
      <ContractorFormModal v-if="modal.active && roleAccessEdit"
                           :state="modal"
                           @set-item-name="setContractorFormItemName"
                           @set-item-full-name="setContractorFormItemFullName"
                           @clear-validation="clearModalValidation"
                           @save-item-info="saveContractorFormItem"
                           @close-modal="closeModal"
      />
      <AppModal v-if="deleteResponseModal.isActive && !deleteResponseModalWithTreaties.isActive && roleAccessRemove"
                :title="deleteResponseModal.title"
                :text="deleteResponseModal.text"
                confirmButtonTitle="Ок"
                :confirmButtonType="deleteResponseModal.type"
                @confirm="closeDeleteModal"
      />

      <AppModal v-if="deleteResponseModalWithTreaties.isActive && roleAccessRemove"
                :title="deleteResponseModalWithTreaties.title"
                :text="deleteResponseModalWithTreaties.text"
                confirmButtonTitle="Ок"
                :confirmButtonType="deleteResponseModalWithTreaties.type"
                @confirm="closeDeleteModalWithTreaties"
      />
    </transition>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>
import SearchForm from '@/components/page/input/SearchForm'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppTable from '@/components/page/table/AppTable'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import ContractorFormModal from '@/components/contractor/ContractorFormModal'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import AppModal from '@/components/page/modal/AppModal'
import VPagination from '@/components/page/VPagination'
import { mapGetters } from 'vuex'

export default {
  name: 'ContractorsFormList',
  components: {
    ContractorFormModal,
    ThePagePreloader,
    AppConfirmation,
    AppNoRecordsPlaceholder,
    AppTable,
    AppButtonSmAdd,
    SearchForm,
    AppButtonSmRemove,
    AppModal,
    VPagination
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null,
        group: false
      }
    }
  },
  computed: {
    ...mapGetters('contractorFormListPage', [
      'getContractorsFormListTableHeaders',
      'getContractorsFormList',
      'getContractorsFormListModal',
      'getContractorsFormListSearchValue',
      'getContractorsFormListFilter',
      'getContractorsFormListPagination',
      'getContractorsFormsListIsLoading',
      'getContractorsFormListResponseModal',
      'getContractorsFormListResponseModalWithTreaties',
      'getContractorsFormListActiveDelete'
    ]),
    tableHeaders () {
      return this.getContractorsFormListTableHeaders
    },
    forms () {
      return this.getContractorsFormList.map(form => {
        return ({
          id: form.id,
          isActive: form.isActive,
          values: [
            form.full_name, form.short_name
          ]
        })
      })
    },
    modal () {
      return this.getContractorsFormListModal
    },
    searchValue () {
      return this.getContractorsFormListSearchValue
    },
    filter () {
      return this.getContractorsFormListFilter
    },
    pagination () {
      return this.getContractorsFormListPagination
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    isLoading () {
      return this.getContractorsFormsListIsLoading
    },
    deleteResponseModal () {
      return this.getContractorsFormListResponseModal
    },
    deleteResponseModalWithTreaties () {
      return this.getContractorsFormListResponseModalWithTreaties
    },
    isActiveDelete () {
      return this.getContractorsFormListActiveDelete
    },
    roleAccessCreate () {
      return this.$store.getters.getRoleRightContractors.actions.add
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightContractors.actions.remove
    },
    roleAccessEdit () {
      return this.$store.getters.getRoleRightContractors.actions.update
    }
  },
  methods: {
    toggleItemControls (itemId) {
      this.$store.dispatch('contractorFormListPage/toggleContractorsFormsListItemControls', itemId)
    },
    toggleActiveItem (itemId) {
      this.$store.dispatch('contractorFormListPage/toggleContractorsFormListItemActive', itemId)
    },
    toggleActiveAll () {
      this.$store.dispatch('contractorFormListPage/toggleContractorsFormListItemActiveAll')
    },
    showModal (itemId) {
      this.$store.dispatch('contractorFormListPage/showContractorsFormsModal', itemId)
    },
    setContractorFormItemName (value) {
      this.$store.dispatch('contractorFormListPage/setContractorsFormItemName', value)
    },
    setContractorFormItemFullName (value) {
      this.$store.dispatch('contractorFormListPage/setContractorsFormItemFullName', value)
    },
    clearModalValidation (inputName) {
      this.$store.dispatch('contractorFormListPage/clearContractorsFormsModalValidation', inputName)
    },
    saveContractorFormItem () {
      this.$store.dispatch('contractorFormListPage/saveContractorsFormItem')
    },
    closeModal () {
      this.$store.dispatch('contractorFormListPage/closeContractorsFormsModal')
    },
    showRemoveConfirmation (id) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = id
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    removeContractorsForm () {
      const itemId = this.removeConfirmation.id
      this.$store.dispatch('contractorFormListPage/removeContractorsForm', itemId)
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    removeContractorsFormGroup () {
      this.$store.dispatch('contractorFormListPage/deleteContractorsFormListCheckedItems')
      this.removeConfirmation.active = false
      this.removeConfirmation.group = false
      this.removeConfirmation.id = null
    },
    showRemoveConfirmationGroup () {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = null
      this.removeConfirmation.group = true
    },
    closeDeleteModal () {
      this.$store.dispatch('contractorFormListPage/closeContractorsFormListDeleteModal')
    },
    closeDeleteModalWithTreaties () {
      this.$store.dispatch('contractorFormListPage/closeContractorsFormListDeleteModalWithTreaties')
    },

    // search
    setSearchValue (value) {
      this.$store.dispatch('contractorFormListPage/setContractorsFormListSearchValue', value)
    },

    // filter

    // pagination
    getPage (pageNum) {
      this.$store.dispatch('contractorFormListPage/getContractorsFormsListPage', pageNum)
    }
  },
  mounted () {
    this.$store.dispatch('contractorFormListPage/getContractorsForms')
  },

  destroyed () {
    this.$store.commit('contractorFormListPage/RESET_CONTRACTORS_FORM_LIST_STORE')
  }
}
</script>

<style lang="scss" scoped>
.no-records {
  margin-top: 80px;
  align-items: center;
  width: 100%;
  display: flex;
}
</style>
